import React  from 'react';
import { Seo } from "../components/seo"
import HomeBrands from "../components/brands/home-brands"
import HeroArea from "../components/hero-banner/hero-area"
import HeroArea2 from "../components/hero-banner/hero-area-2"
import CollectionArea3 from "../components/collections/collection-area-3"
import NewsLetterArea from "../components/newsletter/news-letter-area";
import Layout from "../layout/layout";
import ChoseArea from '../components/why-chose/chose-area-2';
import MintArea from "../components/mint-area/mint-area"
import SectionDivider from "../components/section-divider"
import AboutArea from "../components/about/about-area"
import CollectionArea from "../components/collections/collection-area"
import RoadMapArea from '../components/roadmap-area/roadmap-area-3';
import TeamArea from '../components/teams/team-area';
import FaqArea from '../components/faqs/faq-area';
import CtaArea from '../components/cta/cta-area';
import GradientPosition from '../components/gradient-position';

const HomePage = () => {
  return (
    <Layout>
      <GradientPosition/>
      <HeroArea />
      <SectionDivider />
      <HomeBrands />
      <SectionDivider />
      <AboutArea />
      <SectionDivider />
      <ChoseArea />
      <SectionDivider />
      <HeroArea2 />
      <SectionDivider />
      <MintArea />
      <SectionDivider />
      <CollectionArea3 />
      {/* <SectionDivider /> */}
      {/* <CollectionArea /> */}
      <SectionDivider />
      <RoadMapArea/>
      <SectionDivider />
      <TeamArea/>
      {/* <SectionDivider />
      <FaqArea/> */}
      <SectionDivider />
      <NewsLetterArea />
      {/* <CtaArea/> */}
      <SectionDivider />
    </Layout>
  )
}
export default HomePage;

export const Head = () => <Seo />
